module.exports = __webpack_public_path__ + "img/html-evolution-16.5b614f2e.webp";